// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingLanguagesPanel_root__20vJA","form":"EditListingLanguagesPanel_form__2n62c","title":"EditListingLanguagesPanel_title__1Hp4C"};